module.exports = __webpack_public_path__ + "4a293521d9e2d6bc7bf9079b27af8c0c.svg";